import { useState } from 'react';
import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';

import {
  CustomButton,
  UpdateButton,
} from '../../../components/common/button/CustomButtons';
import { PersitedDatePicker } from '../../../components/common';
import useConfirm from '../../../components/common/useConfirm';
import { useQuery } from '../../../hooks/UseQuery';
import { processes } from './helpers/initialState';

const HeaderCreate = ({
  handleUpdate,
  setModuleData,
  tabValue,
  setTabValue,
}: any) => {
  const date = useQuery('date');
  const [DialogAddRow, confirmAddRow] = useConfirm(
    'Add Row',
    'Are you sure you want to Add Row?'
  );
  return (
    <>
      <Stack
        direction="row"
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          pl: 2,
          pb: 1,
          pt: 2,
          gap: 2,
        }}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: 'start',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <PersitedDatePicker
            label="Search By Year"
            views={['year', 'month']}
          />
        </Stack>
        <ToggleButtonGroup
          exclusive
          value={tabValue}
          onChange={(_, newValue) => setTabValue(+newValue)}
          aria-label="Platform"
        >
          <ToggleButton
            value="0"
            style={{
              backgroundColor: tabValue === 0 ? 'darkblue' : 'inherit',
              color: tabValue === 0 ? 'white' : 'inherit',
            }}
          >
            MECHANICAL ( TOTAL DOWN TIME )
          </ToggleButton>
          <ToggleButton
            value="1"
            style={{
              backgroundColor: tabValue === 1 ? 'darkblue' : 'inherit',
              color: tabValue === 1 ? 'white' : 'inherit',
            }}
          >
            ELECTRICAL ( TOTAL DOWN TIME )
          </ToggleButton>
          <ToggleButton
            value="2"
            style={{
              backgroundColor: tabValue === 2 ? 'darkblue' : 'inherit',
              color: tabValue === 2 ? 'white' : 'inherit',
            }}
          >
            DASHBOARD
          </ToggleButton>
        </ToggleButtonGroup>

        <Stack
          direction="row"
          sx={{
            gap: 2,
          }}
        >
          <CustomButton
            sx={{
              backgroundColor: '#1c7ed6',
            }}
            onClick={async () => {
              const ans = await confirmAddRow();
              if (!ans) return;
              setModuleData((prev: any) => {
                const value = [
                  ...prev,
                  {
                    month: date && new Date(date).getMonth() + 1,
                    year: date && new Date(date).getFullYear(),
                    date: new Date(),
                    tab: tabValue,
                    ...processes[0],
                  },
                ];
                return value;
              });
            }}
          >
            ADD ROWS
          </CustomButton>

          <UpdateButton
            label="update"
            sx={{ mr: '37px', fontSize: '2rem' }}
            size="large"
            onClick={() => {
              handleUpdate();
            }}
          />
        </Stack>
      </Stack>
      <DialogAddRow />
    </>
  );
};

export default HeaderCreate;
